import { unities, unitiesDecimals } from "../constants/unities.constants";

export const getNumericValue = (value?: string | number | null) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(parsed)) return null;
  return parsed;
};

export const getUnitLabel = (unit?: string | null) => {
  if (!unit) return '';
  return unities[unit as keyof typeof unities] || unit;
};

export const getDecimalsForUnit = (unit?: string | null, fallback = 3) => {
  if (!unit) return fallback;
  const decimals = unitiesDecimals[unit as keyof typeof unitiesDecimals];
  return typeof decimals === 'number' ? decimals : fallback;
};